var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGardening = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Gardening-Tools--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Gardening Tools Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.27 0a1 1 0 0 0 -1 1v5.5a3 3 0 0 1 -1.2 2.4 0.53 0.53 0 0 1 -0.53 0 0.5 0.5 0 0 1 -0.27 -0.45V1a1 1 0 0 0 -2 0v7.5a0.5 0.5 0 0 1 -0.8 0.4 3 3 0 0 1 -1.2 -2.4V1a1 1 0 0 0 -2 0v5.5a5 5 0 0 0 3.63 4.81 0.5 0.5 0 0 1 0.37 0.48V15a0.51 0.51 0 0 1 -0.2 0.4 2 2 0 0 0 -0.8 1.6v5a2 2 0 0 0 4 0v-5a2 2 0 0 0 -0.8 -1.6 0.48 0.48 0 0 1 -0.2 -0.4v-3.21a0.5 0.5 0 0 1 0.36 -0.48 5 5 0 0 0 3.64 -4.81V1a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.73 10.94C23.52 8.38 22.51 0 18.27 0S13 8.38 12.82 11a1 1 0 0 0 0.28 0.75 1 1 0 0 0 0.72 0.3h8.91a1 1 0 0 0 0.73 -0.31 1 1 0 0 0 0.27 -0.8Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.47 15.4a0.48 0.48 0 0 1 -0.2 -0.4v-1.5a0.5 0.5 0 0 0 -0.5 -0.5h-1a0.5 0.5 0 0 0 -0.5 0.5V15a0.51 0.51 0 0 1 -0.2 0.4 2 2 0 0 0 -0.8 1.6v5a2 2 0 0 0 4 0v-5a2 2 0 0 0 -0.8 -1.6Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGardening);
export default ForwardRef;